import { Attr, BelongsTo, HasMany, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import Facility from './facility';
import Group from './group';

@Model()
export default class BootSchedule extends ApplicationRecord {
  static jsonapiType = 'boot_schedules';

  @Attr() facilityId: string;
  @Attr() groupId: string;
  @Attr() name: string;
  @Attr() time: string;
  @Attr() daysOfWeek: number[];
  @Attr() targetCount: number;
  @Attr() batchSize: number;
  @Attr() batchDelaySeconds: number;
  @Attr() enabled: boolean;
  @Attr() createdAt: string;
  @Attr() updatedAt: string;

  @BelongsTo() facility: Facility;
  @BelongsTo() group: Group;
}
